import * as PropertyBucket from '../../Properties/Properties.js';
import * as httpService from '../../Components/HttpService/HttpService.js';

export function getPaymentClaimsDataRequested() {
    return {
        type: 'GET_PAYMENT_CLAIMS_DATA_REQUESTED'
    };
}

export function getPaymentClaimsDataDone(data) {
    return {
        type: 'GET_PAYMENT_CLAIMS_DATA_DONE',
        data: data.results
    };
}

export function getPaymentClaimsDataFailed(error) {
    return {
        type: 'GET_PAYMENT_CLAIMS_DATA_FAILED',
        payload: error
    };
}

export function getPaymentClaimsData(projectId) {
    return async dispatch => {
        dispatch(getPaymentClaimsDataRequested());
        try {
            const data = await httpService.getServicePromise(PropertyBucket.getPaymentClaims(projectId), "GET");
            dispatch(getPaymentClaimsDataDone(data));
        } catch (error) {
            dispatch(getPaymentClaimsDataFailed(error));
        }
    };
}


export const GET_PAYMENT_CLAIMS_DATA_REQUESTED = 'GET_PAYMENT_CLAIMS_DATA_REQUESTED';
export const GET_PAYMENT_CLAIMS_DATA_DONE = 'GET_PAYMENT_CLAIMS_DATA_DONE';
export const GET_PAYMENT_CLAIMS_DATA_FAILED = 'GET_PAYMENT_CLAIMS_DATA_FAILED';